/**
 * TEMPORARY: Overtime Approval backend permissions are not ready yet.
 *
 * Single on/off switch for all temporary Overtime Approval frontend bypasses
 * (permission grants, view/create gating, section-assignment bypass, the local
 * dummy request, and mocked submit).
 *
 * Enabled by default. Set `VITE_OVERTIME_APPROVAL_BYPASS=false` to turn every
 * bypass off in one place once the backend supports the workflow.
 */
export const isOvertimeApprovalBypassEnabled: boolean =
  import.meta.env.VITE_OVERTIME_APPROVAL_BYPASS !== 'false';
